import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { DestroyableComponent } from '@models/destroyable.component';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-invite-header',
  templateUrl: './invite-header.component.html',
  styleUrls: ['./invite-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InviteHeaderComponent extends DestroyableComponent implements OnInit {
  errorNotificationService = inject(ErrorNotificationService);
  private fb = inject(UntypedFormBuilder);

  @Output() searchChanged = new EventEmitter<string>();

  @Output() searchClosed = new EventEmitter<boolean>();

  @Input() set searchReset(reset) {
    if (!reset) {
      return;
    }
    this.searchOpened = false;
    this.searchControl.reset();
    this.searchClosed.emit(true);
  }

  public searchOpened = false;
  public searchControl: UntypedFormControl;

  ngOnInit(): void {
    this.searchControl = this.fb.control('');
    this.searchControl.valueChanges
      .pipe(debounceTime(500))
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (value) => {
          this.searchChanged.emit(value);
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public openSearch(): void {
    this.searchOpened = true;
  }

  public closeSearch(): void {
    this.searchOpened = false;
    this.searchControl.reset();
    this.searchClosed.emit(true);
  }
}
